/**
 * @namespace {BX.UI.Icons.Generator}
 */
export default class FileType
{
	static ARCHIVE = 'archive';
	static MEDIA = "media";
	static PICTURE = "picture";
	static AUDIO = 'audio';
	static NONE = "none";
}
